/* eslint-disable max-len */
import { CONTENT } from '@bitComponents/unifiedComponents/Stopper';
import {
  BUTTON_WIDTH,
  BUTTON_HEIGHT,
  BUTTON_COLOR,
} from '@bitComponents/unifiedComponents/Button';
import { USER_TYPE } from '../../../../bitConstants/constants';
import { CALL_GENERIC_1004, URLS, PHONE_900 } from '../../errorTextsConstants';

export const getErrorToPrint = ( goToC2C ) => {
  return {
    common: {
      MAX_CARDINALITY_REACHED: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'Producto ya contratado',
          msg: ['Actualmente ya tienes contratado este producto'],
          errorName: 'produco ya contratado - cardinalidad superada',
        },
      },
      BLOCKED_USER: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'Lamentablemente no podemos ofrecerte este producto',
          msg: [
            'Este producto solo está disponible para usuarios con NIF, NIE o CIF.',
          ],
          buttons: [
            {
              color: BUTTON_COLOR.BLUE,
              onClick: () => {
                window.location.href = URLS.BOOK_SHOP_APPOINTMENT;
              },
              label: 'Solicitar cita previa',
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.MEDIUM,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
            },
          ],
          errorName: 'cif user blocked',
        },
      },
      INCOMPATIBLE_PRODUCT: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          buttons: [
            {
              label: "Llama gratis al 900181004",
              link: 'tel:900181004',
              forceExternal: true,     
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.LIQUID_DOPPED,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
              color: BUTTON_COLOR.BLUE,
            },
          ],
          title: 'Tras revisar tus datos, no podemos ofrecerte este producto.',
          msg: [
            'Para contratar este producto es necesario tener uno de estos servicios de Movistar: Internet, contrato móvil o miMovistar.',
            `Puedes llamar gratis al ${PHONE_900} y un asesor comercial te ayudará`,
          ],
          errorName: 'producto incompatible',
        },
      },
    },
    [`user_${USER_TYPE.TELCO}`]: {
    },
    [`user_${USER_TYPE.OPEN}`]: {
    },
  }
};
